import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { CaseManagementStore } from "Store";
import Icon from "module-common/Icon";
import { Collapse } from "antd";
const Panel = Collapse.Panel;

const customPanelStyle = {
  background: "transparent",
  borderRadius: 0,
  marginBottom: 0,
  border: 0,
  overflow: "hidden",
  borderBottom: "1px solid #ddd"
};

export default class Row extends Component {
  static propTypes = {
    id: PropTypes.number,
    index: PropTypes.number,
    title: PropTypes.string,
    arrOfTemplate: PropTypes.array,
    onConfirm: PropTypes.func
  };

  render() {
    const { id, index, title, arrOfTemplate } = this.props;
    const viewTemplate = arrOfTemplate.map((template, index) => {
      return (
        <Stream key={index}>
          <StreamWord>
            {template.content.split("\n").map((item, key) => {
              return (
                <span key={key}>
                  {item}
                  <br />
                </span>
              );
            })}
          </StreamWord>
          <Icon
            name="plus"
            width={17}
            height={17}
            onClick={this.onAddTemplate.bind(this, template)}
          />
        </Stream>
      );
    });

    return (
      <Wrapper>
        <Collapse bordered={false}>
          <Panel header={title} key={index} style={customPanelStyle}>
            {viewTemplate}
          </Panel>
        </Collapse>
      </Wrapper>
    );
  }
  onAddTemplate = template => {
    const { arrOfTemplate, onConfirm, textTypingSplit } = this.props;
    for (let i = 0; i < arrOfTemplate.length; i++) {
      if (arrOfTemplate[i].content == template.content) {
        CaseManagementStore.message =
          CaseManagementStore.message + arrOfTemplate[i].content;
        onConfirm();
      }
    }
  };
}

const Wrapper = styled.div``;

const Stream = styled.div`
  display: flex;
  background: #e8e8e8;
  padding: 10px;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: 8px;
  justify-content: space-between;
`;

const StreamWord = styled.span``;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/RowWithMutation.js